export class Api {

    //static baseurl ="http://192.168.50.201:3000/api"
    static baseurl = process.env.REACT_APP_API_BASE_URL

    //static baseurl = `http://${this.ip}:${this.port}/api`

    static get = async (url) => {
        try {
            const peticion = await fetch(this.baseurl + url);
            return await peticion.json();
        } catch (error) {
            console.log('errorrrr', error)
        }

    }

    static post = async (url, data) => {
        return fetch(this.baseurl + url, {
            // headers:{'Authorization': token,'Content-Type':'application/json'}
            method: 'POST',
            body: JSON.stringify(data),
            headers: { 'Content-Type': 'application/json' }
        });
    }
}
